import { categories } from '@/mocks/categories';

export default function ProductCategories() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Shop By Category
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto">
            Explore our complete collection across all product categories. Click any category to start shopping on our main store.
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="flex flex-col items-center justify-center gap-2 p-4 bg-background-50 rounded-xl border border-background-200/50 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300 group cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100/80 group-hover:bg-primary-200 transition-colors duration-300">
                <i className={`${cat.icon} text-lg text-primary-600`}></i>
              </div>
              <span className="text-xs text-foreground-700 font-medium text-center leading-tight whitespace-nowrap">
                {cat.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}